import React, { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Button } from '@ui-kitten/components';
import DNABox from "../../layout/DNABox/DNABox";
import DNAIcon from "../../visual/DNAIcon/DNAIcon";
const modifiers = StyleSheet.create({
    stretch: {
        flex: 1,
        alignSelf: 'stretch',
    },
    roundedfull: {
        borderRadius: 1000,
    },
    iconButton: {
        paddingHorizontal: 0,
    },
});
const getIcon = (name, customIcon, customIconName, style, rest) => (p) => {
    const resolvedStyles = useMemo(() => [p.style, style], [p.style, style]);
    if (typeof name === 'string') {
        return (<DNAIcon {...p} style={resolvedStyles} name={name} testID={`icon-${name}`}/>);
    }
    // @ts-ignore [TODO] - Fix typing
    const width = style?.width || p?.style?.width;
    // @ts-ignore [TODO] - Fix typing
    const height = style?.height || p?.style?.height;
    return (<DNAIcon.Styled {...p} {...rest} style={resolvedStyles} name={customIconName} testID={'icon-' + customIconName} width={(typeof width === 'string' || typeof width === 'number') ? width : undefined} height={(typeof height === 'string' || typeof height === 'number') ? height : undefined} CustomIcon={customIcon}/>);
};
export const DNAButton = React.forwardRef(({ iconLeft, iconRight, customIconLeft, customIconRight, customIconName, accessoryLeft, accessoryRight, children, iconStyle, testID, rounded, style, stretch, ...rest }, ref) => {
    const accessories = useMemo(() => ({
        accessoryLeft: iconLeft || customIconLeft
            ? getIcon(iconLeft, customIconLeft, customIconName, iconStyle, rest)
            : accessoryLeft,
        accessoryRight: iconRight || customIconRight
            ? getIcon(iconRight, customIconRight, customIconName, iconStyle, rest)
            : accessoryRight,
    }), [
        iconLeft,
        iconRight,
        customIconLeft,
        customIconRight,
        customIconName,
        iconStyle,
        accessoryLeft,
        accessoryRight,
        rest,
    ]);
    const roundedStyle = rounded ? modifiers.roundedfull : undefined;
    const stretchStyle = stretch ? modifiers.stretch : undefined;
    const isIconButton = (iconLeft ||
        customIconLeft ||
        accessoryLeft ||
        iconRight ||
        customIconRight ||
        accessoryRight) && !children;
    const paddingStyle = isIconButton ? modifiers.iconButton : undefined;
    const resolvedStyles = useMemo(() => [
        style,
        roundedStyle,
        paddingStyle,
        stretchStyle,
    ], [style, roundedStyle, paddingStyle, stretch]);
    return (<DNABox ref={ref} testID={testID} style={stretchStyle}>
      <Button {...accessories} {...rest} style={resolvedStyles}>
        {children}
      </Button>
    </DNABox>);
});
DNAButton.displayName = 'DNAButton';
export default DNAButton;
//# sourceMappingURL=DNAButton.js.map